module.exports = __webpack_public_path__ + "assets/vaccine.5732439f.svg";